(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  // Hero Carousel functionality
  class HeroCarousel {
    constructor(element) {
      this.hero = element;
      this.slides = Array.from(this.hero.querySelectorAll('.hero__carousel-slide'));
      this.prevBtn = this.hero.querySelector('[data-carousel-prev]');
      this.nextBtn = this.hero.querySelector('[data-carousel-next]');
      this.currentIndex = 0;
      this.autoplayInterval = null;
      this.autoplayEnabled = this.hero.dataset.carouselAutoplay === 'true';
      this.autoplayDelay = parseInt(getComputedStyle(this.hero).getPropertyValue('--hero-carousel-autoplay-interval')) || 5000;

      if (this.slides.length < 2) return;

      this.init();
    }

    init() {
      // Show first slide
      this.showSlide(0);

      // Arrow navigation
      this.prevBtn?.addEventListener('click', () => this.prev());
      this.nextBtn?.addEventListener('click', () => this.next());

      // Touch/swipe support
      this.addSwipeSupport();

      // Keyboard navigation
      this.hero.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') this.prev();
        if (e.key === 'ArrowRight') this.next();
      });

      // Autoplay
      if (this.autoplayEnabled) {
        this.startAutoplay();
        
        // Pause on hover
        this.hero.addEventListener('mouseenter', () => this.stopAutoplay());
        this.hero.addEventListener('mouseleave', () => this.startAutoplay());
      }
    }

    showSlide(index) {
      this.slides.forEach((slide, i) => {
        slide.classList.toggle('active', i === index);
      });
      this.currentIndex = index;
    }

    next() {
      const nextIndex = (this.currentIndex + 1) % this.slides.length;
      this.showSlide(nextIndex);
      if (this.autoplayEnabled) {
        this.stopAutoplay();
        this.startAutoplay();
      }
    }

    prev() {
      const prevIndex = (this.currentIndex - 1 + this.slides.length) % this.slides.length;
      this.showSlide(prevIndex);
      if (this.autoplayEnabled) {
        this.stopAutoplay();
        this.startAutoplay();
      }
    }

    startAutoplay() {
      this.stopAutoplay();
      this.autoplayInterval = setInterval(() => this.next(), this.autoplayDelay);
    }

    stopAutoplay() {
      if (this.autoplayInterval) {
        clearInterval(this.autoplayInterval);
        this.autoplayInterval = null;
      }
    }

    addSwipeSupport() {
      let startX = 0;
      let endX = 0;

      this.hero.addEventListener('touchstart', (e) => {
        startX = e.touches[0].clientX;
      }, { passive: true });

      this.hero.addEventListener('touchmove', (e) => {
        endX = e.touches[0].clientX;
      }, { passive: true });

      this.hero.addEventListener('touchend', () => {
        const diff = startX - endX;
        if (Math.abs(diff) > 50) {
          if (diff > 0) {
            this.next();
          } else {
            this.prev();
          }
        }
      });
    }
  }

  // Initialize all hero carousels
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-carousel="true"]').forEach(el => {
      new HeroCarousel(el);
    });
  });

  // Shopify theme editor support
  if (Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', (e) => {
      const carousel = e.target.querySelector('[data-carousel="true"]');
      if (carousel) new HeroCarousel(carousel);
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
